import React from "react";
import { CircleMarker, MapContainer, Popup, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const MapPropertyLocation = ({ marker }) => {
  return (
    <MapContainer
      center={[marker.lat, marker.lng]}
      zoom={16}
      scrollWheelZoom={false}
      style={{zIndex:"0"}}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <CircleMarker
        center={[marker.lat, marker.lng]}
        pathOptions={{ color: "#FF4E00" }}
        radius={100}
      >
        <Popup> Popup in CircleMarker </Popup>
      </CircleMarker>
    </MapContainer>
  );
};

export default MapPropertyLocation;
